var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "#4C4C4C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.808058 0.683058C0.582756 0.908361 0.565425 1.26288 0.756065 1.50806L0.808058 1.56694L4.55806 5.31694C4.78336 5.54224 5.13788 5.55958 5.38306 5.36893L5.44194 5.31694L9.19194 1.56694C9.43602 1.32286 9.43602 0.927136 9.19194 0.683058C8.96664 0.457756 8.61212 0.440425 8.36694 0.631065L8.30806 0.683058L5 3.99062L1.69194 0.683058C1.46664 0.457756 1.11212 0.440425 0.866938 0.631065L0.808058 0.683058Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowDown.ffeea3a60e35ac6b915095a042260b94.svg";